module.exports = __webpack_public_path__ + "static/img/s4.33ef3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/s4.png
// module id = vNMp
// module chunks = 1